import Circle from './components/Circle.vue'
import Circle2 from './components/Circle2.vue'
import Circle3 from './components/Circle3.vue'
import Circle4 from './components/Circle4.vue'
import Circle5 from './components/Circle5.vue'
import Circle6 from './components/Circle6.vue'
import Circle7 from './components/Circle7.vue'
import Circle8 from './components/Circle8.vue'
import Circle9 from './components/Circle9.vue'
import Circle10 from './components/Circle10.vue'
import Circle11 from './components/Circle11.vue'
import CubeShadow from './components/CubeShadow.vue'
import Diamond from './components/Diamond.vue'
import DoubleBounce from './components/DoubleBounce.vue'
import Gauge from './components/Gauge.vue'
import Google from './components/Google.vue'
import Hexagon from './components/Hexagon.vue'
import HourGlass from './components/HourGlass.vue'
import Jawn from './components/Jawn.vue'
import Jumper from './components/Jumper.vue'
import LetterCube from './components/LetterCube.vue'
import MikePad from './components/Mikepad.vue'
import Origami from './components/Origami.vue'
import Pencil from './components/Pencil.vue'
import PingPong from './components/PingPong.vue'
import Plane from './components/Plane.vue'
import RotateSquare from './components/RotateSquare.vue'
import RotateSquare2 from './components/RotateSquare2.vue'
import RotateSquare3 from './components/RotateSquare3.vue'
import RotateSquare4 from './components/RotateSquare4.vue'
import RotateSquare5 from './components/RotateSquare5.vue'
import ScaleOut from './components/ScaleOut.vue'
import Socket from './components/Socket.vue'
import SpinLine from './components/SpinLine.vue'
import SquareGrid from './components/SquareGrid.vue'
import Stretch from './components/Stretch.vue'
import Texture from './components/Texture.vue'
import ThreeDots from './components/ThreeDots.vue'
import TwoCube from './components/TwoCube.vue'
import Wave from './components/Wave.vue'

export {
  Circle,
  Circle2,
  Circle3,
  Circle4,
  Circle5,
  Circle6,
  Circle7,
  Circle8,
  Circle9,
  Circle10,
  Circle11,
  CubeShadow,
  Diamond,
  DoubleBounce,
  Gauge,
  Google,
  Hexagon,
  HourGlass,
  Jawn,
  Jumper,
  LetterCube,
  MikePad,
  Origami,
  Pencil,
  PingPong,
  Plane,
  RotateSquare,
  RotateSquare2,
  RotateSquare3,
  RotateSquare4,
  RotateSquare5,
  ScaleOut,
  Socket,
  SpinLine,
  SquareGrid,
  Stretch,
  Texture,
  ThreeDots,
  TwoCube,
  Wave
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-loading-spinner/src/index.js
// module id = 1HBs
// module chunks = 1